import { z } from 'zod';

/**
 * Name bounds mirror the backend's `Whiteboard.NameRequired` / `Whiteboard.NameTooLong` rules.
 *
 * @remarks
 * Messages are i18n keys in `namespace:path` form — `FieldError` in `shared/components/ui/field.tsx`
 * resolves them at render time. The dotted form without a namespace prefix does not match its
 * pattern and would surface the raw key to the user.
 */
export const whiteboardFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { error: 'whiteboards:form.validation.nameRequired' })
    .max(120, { error: 'whiteboards:form.validation.nameTooLong' }),
});

export type WhiteboardFormValues = z.infer<typeof whiteboardFormSchema>;
